module.exports = __webpack_public_path__ + "static/media/nd-bg10.152d2cf3.jpg";